import { snookerPointsRemaining } from './snookerScoring';

export const STATS_DURATION_MS = 10000;
export const STATS_INTERVAL_MS = 60000;
export const STATS_QUIET_MS = 6000;
export const normalizeStatsMode = mode => ['auto', 'manual', 'always'].includes(mode) ? mode : 'auto';
export const statsFrameKey = state => `${state.currentFrame}:${state.player1FramesWon}:${state.player2FramesWon}`;

export const snookerFrameStats = state => {
    const first = Number(state.player1Score) || 0;
    const second = Number(state.player2Score) || 0;
    const difference = Number(state.currentPlayer) === 2 ? second - first : first - second;
    const reds = Number(state.redsRemaining);
    const validReds = Number.isInteger(reds) && reds >= 0 && reds <= 15;
    return {
        label: difference > 0 ? 'Ahead' : difference < 0 ? 'Behind' : 'Level',
        difference: Math.abs(difference),
        // Use physical ball state, never score / 8: fouls and lower colours make
        // that estimate wrong. Free-ball pots must not remove a real red.
        reds: validReds ? reds : null,
        remaining: validReds ? snookerPointsRemaining({ ...state, redsRemaining: reds }) : null,
        player: Number(state.currentPlayer) === 2 ? state.secondPlayer : state.firstPlayer,
    };
};

export const streamingStatsVisible = ({ state, mode, now, lastScoreAt, ready }) => {
    if (!ready || state.frameOver || state.isGameFinished) return false;
    const command = state.streamingStatsCommand;
    if (command?.frame === statsFrameKey(state)) {
        if (command.action === 'hide') return false;
        if (command.action === 'show' && Number(command.expiresAt) > now) return true;
    }
    const resolvedMode = normalizeStatsMode(mode);
    if (resolvedMode === 'manual') return false;
    if (resolvedMode === 'always') return true;
    const started = Number(state.player1Score) > 0 || Number(state.player2Score) > 0 || Number(state.redsRemaining) < 15;
    // All OBS sources share the wall-clock cycle. Scoring takes priority over
    // automatic stats; explicit Show now remains available during a break.
    return started && now - lastScoreAt >= STATS_QUIET_MS
        && now % STATS_INTERVAL_MS >= STATS_INTERVAL_MS - STATS_DURATION_MS;
};
